/**
 * 特集コンテンツのループ動画
 * ブラウザのネイティブループによる再開時の映像乱れを防ぐ
 */

/**
 * ループ動画を先頭へ戻して再生する
 */
const restartLoopVideo = (video: HTMLVideoElement): void => {
  video.currentTime = 0.001;
  const playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise.catch(() => {
      // 自動再生ポリシーで拒否された場合は何もしない
    });
  }
};

/**
 * 特集コンテンツのループ動画を初期化
 */
const initFeatureLoopVideos = (): void => {
  const wrappers = document.querySelectorAll("[data-feature-loop-video]");

  wrappers.forEach((wrapper) => {
    const video = wrapper.querySelector("video");
    if (!(video instanceof HTMLVideoElement)) return;
    if (video.hasAttribute("loop")) return;

    let restarting = false;

    const restart = (): void => {
      if (restarting) return;
      restarting = true;
      restartLoopVideo(video);
    };

    video.addEventListener("seeked", () => {
      restarting = false;
    });

    video.addEventListener("ended", restart);

    // 修正: 終端直前で先頭へ戻し、ループ切り替わり時のデコード乱れを避ける
    video.addEventListener("timeupdate", () => {
      if (!Number.isFinite(video.duration) || video.duration <= 0.2) return;
      if (video.duration - video.currentTime > 0.12) return;
      restart();
    });
  });
};

/**
 * 特集コンテンツを初期化
 */
export function featureContent(): void {
  initFeatureLoopVideos();
}
